import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Calendar, ArrowRight } from 'lucide-react';
import { fetchCollection } from '../../lib/cms';
import SEO from '../../components/SEO';

export default function TilbehoerDe() {
  const [tilbehoerList, setTilbehoerList] = useState([]);

  useEffect(() => {
    async function loadData() {
      const data = await fetchCollection('tilbehoer', 'de');
      setTilbehoerList(data);
    }
    loadData();
  }, []);

  return (
    <div className="relative min-h-screen bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="Original-Zubehör für den Danshaker"
        description="Entdecken Sie passgenaues Original-Zubehör für Ihre Danshaker Entmistungs- und Sortiermaschine. Werkzeughalter, Sonderfarben, Seitenrutsche und mehr."
        path="/de/zubehoer"
        lang="de"
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Header Section */}
      <section className="mx-auto max-w-7xl px-4 pt-16 pb-12 md:px-8 md:pt-24">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/10 px-4 py-1.5 text-xs font-bold text-[#0E67A2]">
            <Sparkles className="h-3.5 w-3.5" aria-hidden="true" />
            <span>Erweitern Sie Ihre Maschine</span>
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
            Original-Zubehör
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed">
            Unser gesamtes Zubehör ist so konzipiert, dass es perfekt auf Ihren Danshaker passt und jederzeit schnell und unkompliziert nachgerüstet werden kann.
          </p>
          <p className="text-xs text-slate-500 font-semibold uppercase tracking-widest">
            Alle Preise exkl. MwSt. in Euro (€)
          </p>
        </div>
      </section>

      {/* Accessories Grid */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-8">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {tilbehoerList.map((item, index) => (
            <div
              key={index}
              className="flex flex-col justify-between overflow-hidden rounded-3xl border border-slate-200 bg-white p-6 shadow-xl transition hover:shadow-2xl hover:border-[#0E67A2]/20"
            >
              <div className="space-y-4">
                {item.image && item.image[0] ? (
                  <div className="aspect-4/3 overflow-hidden rounded-2xl bg-slate-100">
                    <img
                      src={item.image[0]}
                      alt={item.name}
                      width="500"
                      height="375"
                      loading="lazy"
                      decoding="async"
                      className="h-full w-full object-cover transition duration-300 hover:scale-105"
                    />
                  </div>
                ) : (
                  <div className="aspect-4/3 rounded-2xl bg-slate-100 flex items-center justify-center text-slate-400">
                    Kein Bild verfügbar
                  </div>
                )}
                <div>
                  <h3 className="text-xl font-bold text-slate-900">{item.name}</h3>
                  <p className="mt-1 text-sm text-slate-600 font-medium">{item.description}</p>
                </div>
              </div>

              <div className="mt-6 flex items-center justify-between border-t border-slate-100 pt-4">
                <span className="text-xl font-extrabold text-[#0E67A2]">{item.price}</span>
                <Link
                  to="/de/kontakt"
                  className="rounded-xl bg-slate-100 px-4 py-2 text-xs font-bold text-slate-800 transition hover:bg-slate-200"
                >
                  Bestellen / Anfragen
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="mt-16 rounded-3xl bg-slate-900 p-8 md:p-12 text-center text-white space-y-6 shadow-2xl">
          <h2 className="text-3xl font-extrabold sm:text-4xl">Haben Sie Fragen zum Zubehör?</h2>
          <p className="mx-auto max-w-2xl text-slate-300 text-base md:text-lg">
            Wir beraten Sie gerne zu Sonderfarben, Halterungen und individueller Ausstattung für Ihren Stall.
          </p>
          <div className="pt-2 flex flex-wrap justify-center gap-4">
            <Link
              to="/de/kontakt"
              className="inline-flex items-center gap-2 rounded-xl bg-[#0E67A2] px-8 py-4 font-bold text-white shadow-lg transition hover:bg-[#0E67A2]/90"
            >
              Kontakt aufnehmen
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/de/kostenlose-demo"
              className="inline-flex items-center gap-2 rounded-xl border border-slate-700 bg-slate-800 px-8 py-4 font-bold text-white transition hover:bg-slate-700"
            >
              <Calendar className="h-4 w-4" />
              Demo anfordern
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
